import React from "react";

export type ChannelsContextType = {
    channel: string;
    partnerType: string;
    toChannelsPath: (path: string) => string;
    normalizePath: (path: string) => string;
};

export const channelsContext = React.createContext<ChannelsContextType>(null);
